/* Glyfa · Club-Zuordnung (22.10.2026): merkt sich den Club-Code aus Link oder Club-Seite und schreibt ihn als Warenkorb-Attribut "club". Kein Preiseffekt. */
(function () {
  'use strict';
  var KEY = 'gp_club';
  function save(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  var q = new URLSearchParams(location.search);
  var el = document.querySelector('[data-club-slug]');
  var slug = (q.get('club') || (el && el.getAttribute('data-club-slug')) || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 40);
  if (slug) {
    var o = { club: slug };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { var v = q.get(k); if (v) o[k] = v.slice(0, 60); });
    save(o);
  }
  var origFetch = window.fetch;
  function setAttrs() {
    var s = load();
    if (!s || !s.club) return;
    var a = {};
    Object.keys(s).forEach(function (k) { a[k] = s[k]; });
    origFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function () {});
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) { p.then(function (r) { if (r && r.ok) setAttrs(); }).catch(function () {}); }
    return p;
  };
  document.addEventListener('DOMContentLoaded', function () {
    var inp = document.querySelector('[data-club-code]');
    var s = load();
    if (inp && !inp.value && s && s.club) inp.value = s.club;
  });
})();
